import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
export var VectorTileData;
(function (VectorTileData) {
    VectorTileData["ISO_LINES"] = "isolines";
    VectorTileData["AVIATION_REPORT"] = "aviation_reports";
    VectorTileData["SYMBOLS"] = "symbols";
    VectorTileData["BARBS"] = "barbs";
    VectorTileData["NWA"] = "weather_reports";
})(VectorTileData || (VectorTileData = {}));
export function VectorTileRequest_toTransferable(req) {
    return {
        ...req,
        datetime: DateTime_toTransferable(req.datetime),
    };
}
export function VectorTileRequest_fromTransferable(req) {
    return {
        ...req,
        datetime: DateTime_fromTransferable(req.datetime),
    };
}
//# sourceMappingURL=VectorTileRequest.js.map